import SEOTestPage from '../../components/SEOTestPage';
import { SEO_TESTS } from '../../data/seoTestsConfig';
export default function DijitalDikkatTestiPage() {
  return <SEOTestPage testConfig={SEO_TESTS['dijital-dikkat-daginikligi-testi']} />;
}
